export const getError = state => state.editLights.get('error')
export const getIsSubmitting = state => state.editLights.get('isSubmitting')
